



























































































































































import Vue from "vue";
import { mapActions, mapGetters, mapState } from "vuex";

import iwEmail from "@/encoding/pages/questions/contactinformations/Email.vue";
import iwPhoneNumber from "@/encoding/pages/questions/contactinformations/PhoneNumber.vue";
import iwGsmNumber from "@/encoding/pages/questions/contactinformations/GsmNumber.vue";
import iwCallingTimes from "@/encoding/pages/questions/contactinformations/CallingTimes.vue";
import iwCustomerModal from "@/optimizedEncoding/components/contactInformation/CustomerModal.vue";
import { i18n } from "@/shared/scripts/helpers/translation/i18n";
import iwCustomerAddressModal from "@/optimizedEncoding/components/contactInformation/CustomerAddressModal.vue";
import iwButtonLoading from "@/shared/components/ButtonLoading.vue";
import { Customer } from "@/shared/interfaces/customer/Customer.interface";
import { validateCustomerForm } from "@/shared/scripts/ValidateCustomer";
import { updateClassified, stripIncompleteOutdoorFeatures } from "@/shared/scripts/ValidateData";
import iwChangeCustomerPhoneAlertModal from "@/optimizedEncoding/components/contactInformation/ChangeCustomerPhoneAlertModal.vue";
import { pushPageViewEvent } from "@/shared/store/modules/gtm/datalayer";
import {
    hasValidBillboardBillingAddress,
    isBillboardSelected
} from "@/shared/scripts/helpers/customer/billingAddress";
import { removeBillboardAndNotify } from "@/optimizedEncoding/scripts/helpers/billboardEligibility";
import { OrderApiError } from "@/shared/interfaces/order/Order.interface";
import missingCustomerNameMixin from "@/shared/mixins/missingCustomerName";

export default missingCustomerNameMixin.extend({
    components: {
        iwEmail: iwEmail,
        iwPhoneNumber: iwPhoneNumber,
        iwGsmNumber: iwGsmNumber,
        iwCallingTimes: iwCallingTimes,
        iwCustomerModal: iwCustomerModal,
        iwCustomerAddressModal: iwCustomerAddressModal,
        iwButtonLoading: iwButtonLoading,
        iwChangeCustomerPhoneAlertModal: iwChangeCustomerPhoneAlertModal,
    },

    props: {
        isNextSectionVisible: {
            type: Boolean,
            required: false,
            default: false,
        },
    },

    data: function() {
        return {
            error: "",
            loginEmail: "",
            loginPassword: "",
            loginRemember: false,
            isSubmitButtonDisabled:false,
            isSubscriptionDisplay: false,
            newCustomerModalVisible: false,
            appIsReady: false,
            isButtonDisabled: false as boolean,
            validationChecking: false,
            isCustomerAddressModalVisible: false,
            billboardAddressError: "",
            isBillingAddressInvalid: false,
            isFinalizingPublication: false as boolean,
        };
    },

    computed: {
        ...mapState("CustomersModule", [
            "currentCustomer",
            "customers",
            "isChangeCustomerPhoneAlertModalVisible",
            "isCustomerContactDetailsChange"
        ]),
        ...mapState("UserModule", ["user"]),
        ...mapGetters({
            hasApiErrors: "FormModule/hasErrors",
            isLogged: "UserModule/isLogged",
        }),
        isLoginModalOpen: function(): boolean {
            return this.$store.getters["ModalModule/isModalOpen"];
        },
        customerFormError: function(): string | undefined {
            const errors = this.$store.state.CustomersModule.customerFormError;

            if (errors) {
                return errors.customers;
            }

            return;

        },
        errorCustomer: function(): boolean {
            return this.$store.getters["FormModule/getValueUI"]("error.customer") || false;
        },
    },
    watch: {
        currentCustomer: function() {
            this.isBillingAddressInvalid = false;
            this.billboardAddressError = "";
        },
    },

    mounted: function() {
        pushPageViewEvent("classified_deposit_v2_step8_contact_details");
        this.getUserCustomers();
    },

    methods: {
        ...mapActions("CustomersModule", ["createCustomer", "updateCustomer", "getCustomers"]),
        closeLoginModal: function() {
            this.$store.commit("ModalModule/closeModal");
        },
        openLoginModal: function() {
            this.$store.commit("ModalModule/openModal");
        },
        openNewCustomerModal: function() {
            this.newCustomerModalVisible = true;
            this.$store.commit("FormModule/addValueUI", {path: "customer.customerToEdit", value: null});
        },
        openCustomerAddressModal: function() {
            this.isBillingAddressInvalid = false;
            this.isCustomerAddressModalVisible = true;
        },
        closeNewCustomerModal: function() {
            this.newCustomerModalVisible = false;
            this.$store.commit("FormModule/addValueUI", {path: "customer.customerToEdit", value: null});
        },
        closeCustomerAddressModal: function() {
            this.isCustomerAddressModalVisible = false;
        },
        openEditCustomerModal: function(customer: Customer) {
            this.newCustomerModalVisible = true;
            this.$store.commit("FormModule/addValueUI", {path: "customer.customerToEdit", value: customer});
        },
        preselectCustomer: function() {
            if (this.customers.length > 0) {
                this.$store.commit("CustomersModule/setInitialCustomer", this.customers[0]);
                this.$store.commit("CustomersModule/selectCurrentCustomer", 0);
                this.$store.commit("CustomersModule/setCustomerId", this.customers[0].id);
                removeBillboardAndNotify();
            }
        },
        getUserCustomers: function() {
            this.getCustomers()
                .then(() => {
                    this.preselectCustomer();
                    this.appIsReady = true;
                })
                .catch(() => this.dialog.alert(i18n.t("server_not_responding_error").toString()));
        },
        validateAndContinue: function() {
            this.billboardAddressError = "";
            validateCustomerForm((success:boolean) => {
                Vue.nextTick(() => {
                    const inputsError = document.getElementsByClassName("input--error") as HTMLCollectionOf<HTMLElement>;
                    if (inputsError.length > 0) {
                        inputsError[0].focus();
                        window.scrollTo(0, 0);
                    }
                });
                if (success) {
                    if (this.currentCustomer) {
                        if (!this.validateBillboardAddress(this.currentCustomer)) {
                            this.validationChecking = false;
                            this.isButtonDisabled = false;
                            return;
                        }

                        if (!this.currentCustomer.isNew) {
                            // Edit an allready existing customer
                            if (this.isCustomerContactDetailsChange) {
                                this.validationChecking = false;
                                this.$store.commit("CustomersModule/openChangeCustomerPhoneAlertModal");
                            } else {
                                this.updateCustomer(this.currentCustomer).then(success => {
                                    if(success) {
                                        this.$store.commit("CustomersModule/setIsCustomerContactDetailsChange", false);
                                        this.validateAndUpdateClassified();
                                    } else {
                                        // updateCustomer resolves false on a 4xx rather than
                                        // rejecting, so without this the click did nothing at all.
                                        this.$store.commit("FormModule/addValueUI", { "path": "error.customer", "value": true });
                                    }
                                })
                                    .catch(() => this.dialog.alert(i18n.t("server_not_responding_error").toString()))
                                    .finally(() => this.validationChecking = false);
                            }
                        }
                    } else {
                        // Create the first customer
                        const newCustomer = this.$store.getters["FormModule/getValueUI"]("customer") as Customer;

                        if (!this.validateBillboardAddress(newCustomer)) {
                            this.validationChecking = false;
                            this.isButtonDisabled = false;
                            return;
                        }

                        this.createCustomer(newCustomer).then(success => {
                            if(success) {
                                this.validateAndUpdateClassified();
                            } else {
                                this.$store.commit("FormModule/addValueUI", {"path": "error.customer", "value": true});
                                this.validationChecking = false;
                            }
                        }).catch(() => {
                            this.dialog.alert(i18n.t("server_not_responding_error").toString());
                            this.validationChecking = false;
                        });
                    }
                } else {
                    this.validationChecking = false;
                    this.isButtonDisabled  = false;
                }
            });
        },
        finalizePublication: function(): void {
            // Revealing the payment section is what used to hide the CTA, and that emit now waits
            // for the order POST (see below), so the button stays live across it. Every order is a
            // B2C log to Salesforce, so re-entry has to be refused outright rather than merely
            // discouraged — the flag also drives the button's disabled + spinner state.
            if (this.isFinalizingPublication) {
                return;
            }

            // IO-154: the order is what emits the B2C log to Salesforce, so the name has to be
            // usable BEFORE this point — guarding the payment click is too late. Checked before the
            // flag is raised, so the modal's retry can re-enter this method.
            if (this.blockOnMissingCustomerName(this.finalizePublication)) {
                this.isButtonDisabled = false;
                this.validationChecking = false;
                return;
            }

            this.isFinalizingPublication = true;

            this.$store.dispatch("OrdersModule/createOrder")
                .then(() => {
                    this.isFinalizingPublication = false;
                    // Only reveal the payment section once the order exists: nothing can re-hide
                    // this section, and Payment renders nothing actionable without a currentOrder,
                    // so emitting on a failed order would park the user on a dead end.
                    this.$emit("section-completed");
                })
                .catch((errors: Array<OrderApiError>) => {
                    this.isFinalizingPublication = false;
                    if (this.openModalOnMissingCustomerNameError(errors, this.finalizePublication)) {
                        return;
                    }
                    this.dialog.alert(i18n.t("server_not_responding_error").toString());
                });
        },
        validateBillboardAddress: function(customer: Customer | null): boolean {
            if (!isBillboardSelected(
                this.$store.getters["FormModule/getValueTransaction"],
                this.$store.getters["FormModule/getValueOrder"]
            )) {
                this.isBillingAddressInvalid = false;
                return true;
            }

            if (hasValidBillboardBillingAddress(customer)) {
                this.isBillingAddressInvalid = false;
                return true;
            }

            this.billboardAddressError = this.$t("billboard_complete_billing_address_required") as string;
            this.isBillingAddressInvalid = true;
            this.dialog.alert(this.billboardAddressError);
            return false;
        },
        validateAndUpdateClassified: function() {
            updateClassified((success:boolean) => {
                this.isButtonDisabled = true;
                Vue.nextTick(() => {
                    this.isButtonDisabled = false;
                    if (success) {
                        this.proceedToFinalizePublication();
                        if(!this.hasApiErrors) {
                            this.$store.commit("ModalModule/openWarningModal");
                        } else {
                            console.log("error");
                        }
                    }
                });
            });
        },
        proceedToFinalizePublication: function() {
            // A step navigation earlier in the funnel can silently reintroduce an incomplete
            // Realo-populated outdoor feature (see ClassifiedsApi.ts's getClassifiedId), even
            // though the update above just succeeded - that check is scoped to this step only.
            // Order creation checks the whole classified, so re-check and re-save right before it.
            const removedPaths = stripIncompleteOutdoorFeatures();
            if (removedPaths.length === 0) {
                this.finalizePublication();
                return;
            }

            updateClassified((retrySuccess: boolean) => {
                if (retrySuccess) {
                    this.finalizePublication();
                }
            });
        },
        phoneChangesApplied: function() {
            this.finalizePublication();
        }
    }
});

